export  function debounce(fn, wait = 200, immediate = false) {
  let timer = null;

  return function (...args) {
      const context = this;

      const later = () => {
          timer = null;
          if (!immediate) {
              fn.apply(context, args);
          }
      };

      const callNow = immediate && !timer;

      clearTimeout(timer);
      timer = setTimeout(later, wait);

      if (callNow) {
          fn.apply(context, args);
      }
  };
}
export const isTimeReached =  function(targetTime) {
    // 将传入的时间字符串转换为 Date 对象
    // 将2024-10-22 10:00:00转为2024/10/22 10:00:00格式
    targetTime = targetTime.replace(/-/g, '/');
    const targetDate = new Date(targetTime).getTime();
  
    // 获取当前时间
    const currentDate = new Date().getTime();
  
    // 比较当前时间和目标时间
    if (currentDate >= targetDate) {
      return true;
    } else {
      return false;
    }
  }